// Métricas y rótulos derivados de Ventas del Admin VL: meta del día, «vs 7d», comisión y corte.
import { CommissionAccrualStatusEnum } from '@fiado/type-kit/bin/retailCommission/enums/CommissionAccrualStatusEnum';
import type { SaleAccrual } from '@/api/services/retail-commission/commissions.client';

/** Avance de lo vendido hoy contra la meta del día, en %. `null` sin meta cargada. */
export function dayGoalPercent(soldTodayCents: number, goalCents: number | null): number | null {
    if (goalCents === null || goalCents <= 0) return null;
    return Math.round((soldTodayCents / goalCents) * 100);
}

/** Piezas de hoy contra el mismo día de la semana pasada, en %. `null` sin base que comparar. */
export function unitsVsBaselinePercent(
    unitsToday: number,
    baselineUnits: number | null,
): number | null {
    if (baselineUnits === null || baselineUnits <= 0) return null;
    return Math.round(((unitsToday - baselineUnits) / baselineUnits) * 100);
}

/** «+12%», «−77%» o «0%», con el signo menos tipográfico. */
export function signedPercent(pct: number): string {
    if (pct > 0) return `+${String(pct)}%`;
    if (pct < 0) return `−${String(Math.abs(pct))}%`;
    return '0%';
}

export type MetricTone = 'success' | 'warning' | 'danger';

/** Color del avance de la meta: verde desde 100%, ámbar desde 70%, rojo abajo. */
export function goalTone(pct: number): MetricTone {
    if (pct >= 100) return 'success';
    if (pct >= 70) return 'warning';
    return 'danger';
}

/** Lo que paga el devengo: lo liquidado al cierre o, antes, el bono por venta. */
export function accrualAmountCents(
    accrual: Pick<SaleAccrual, 'settledAmountCents' | 'subtotalBonusCents' | 'baseAmountCents'>,
): number {
    return accrual.settledAmountCents ?? accrual.subtotalBonusCents ?? accrual.baseAmountCents;
}

export interface CutStatusChip {
    label: string;
    variant: 'warning' | 'success' | 'danger' | 'muted';
}

/** Chip del corte por estado del devengo; las llaves son los valores del enum. */
const CUT_STATUS_CHIP: Record<string, CutStatusChip> = {
    [CommissionAccrualStatusEnum.ACCRUED]: { label: 'Abierto', variant: 'warning' },
    [CommissionAccrualStatusEnum.PAID]: { label: 'Cerrado', variant: 'success' },
    [CommissionAccrualStatusEnum.REVERSED]: { label: 'Descontado', variant: 'danger' },
};

/** Estado del corte visto desde el devengo de la venta: abierto, cerrado o descontado. */
export function cutStatusChip(status: string): CutStatusChip {
    return CUT_STATUS_CHIP[status] ?? { label: status, variant: 'muted' };
}

/** El primer nombre del vendedor para la columna angosta; el nombre completo va en el tooltip. */
export function sellerShortName(sellerName: string | null): string | null {
    const first = sellerName?.trim().split(/\s+/)[0];
    return first ? first : null;
}
